// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.world-editor {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  position: fixed;
  top: 16px;
  left: 16px;
  bottom: 16px;
  width: min(800px, 66vw);
  min-width: 560px;
  display: flex;
  flex-direction: column;
  z-index: 45;
  overflow: hidden;
}
.world-editor * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .world-editor {
    animation: none;
  }
}
.world-editor__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 6px;
}
.world-editor__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 22px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
  margin: 0;
}
.world-editor__sub-title {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 4px 0 0;
}
.world-editor__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
}
.world-editor__close:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__close:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__close:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__close:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.world-editor__modes {
  display: flex;
  gap: 2px;
  padding: 0 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.world-editor__mode {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.world-editor__mode:hover {
  color: #ebe8e1;
}
.world-editor__mode:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.world-editor__mode.is-active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.world-editor__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 14px 0;
  gap: 10px;
}
.world-editor__foot {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  padding: 8px 18px 12px;
  font-size: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.world-editor__search {
  position: relative;
  flex: none;
}
.world-editor__search input {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding-right: 74px;
}
.world-editor__search input:focus {
  outline: none;
  border-color: var(--gold-main);
}
.world-editor__search input::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.world-editor__search--inline {
  display: flex;
  gap: 8px;
}
.world-editor__search--inline input {
  padding-right: 11px;
}
.world-editor__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 10px;
  font-size: 13px;
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
}
.world-editor__clear:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__clear:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__clear:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__clear:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__clear:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.world-editor__shelves {
  flex: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px;
}
.world-editor__shelf {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
  padding: 5px 4px;
  font-size: 12.5px;
}
.world-editor__shelf:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__shelf:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__shelf:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__shelf:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__shelf:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.world-editor__shelf.is-active {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border-color: var(--gold-dark);
}
.world-editor__split {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  gap: 14px;
}
.world-editor__tree {
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-right: 12px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.world-editor__content {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.world-editor__nodes {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 4px;
}
.world-editor__nodes::-webkit-scrollbar {
  width: 6px;
}
.world-editor__nodes::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.world-editor__node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 6px 8px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-left: 2px solid transparent;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.world-editor__node:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.06);
}
.world-editor__node:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.world-editor__node--d1 {
  padding-left: 20px;
  font-weight: 500;
  font-size: 13px;
}
.world-editor__node--d2 {
  padding-left: 34px;
  font-weight: 400;
  font-size: 12.5px;
  color: #8d8a82;
}
.world-editor__node.is-active {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
  border-left-color: var(--gold-main);
}
.world-editor__node-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__source {
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.world-editor__source > span {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  font-size: 12px;
}
.world-editor__source select {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  padding: 7px 9px;
  font-size: 13px;
}
.world-editor__source select:focus {
  outline: none;
  border-color: var(--gold-main);
}
.world-editor__source select::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.world-editor__hint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 0;
}
.world-editor__trail {
  flex: none;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
}
.world-editor__trail-path {
  font-weight: 600;
  color: #ebe8e1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__trail-count {
  flex: none;
  color: #8d8a82;
}
.world-editor__sizehint {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  margin: 0;
  padding-bottom: 8px;
  font-size: 12px;
}
.world-editor__grid-wrap {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  padding-right: 4px;
}
.world-editor__grid-wrap::-webkit-scrollbar {
  width: 6px;
}
.world-editor__grid-wrap::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.world-editor__grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.world-editor__card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 34px 8px 8px;
  min-width: 0;
  cursor: pointer;
  transition: border-color 0.12s ease, background-color 0.12s ease;
}
.world-editor__card:hover {
  border-color: var(--gold-dark);
  background: rgba(255, 255, 255, 0.07);
}
.world-editor__card:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__card.is-selected {
  border-color: var(--gold-main);
  background: rgba(255, 255, 255, 0.09);
}
.world-editor__tile {
  flex: none;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: 17px;
  color: var(--gold-light);
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}
.world-editor__card-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.world-editor__card-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
}
.world-editor__card-meta {
  font-size: 12px;
  color: #8d8a82;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__star {
  position: absolute;
  top: 6px;
  right: 6px;
  display: grid;
  place-items: center;
  width: 26px;
  height: 26px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
.world-editor__star svg {
  fill: none;
  stroke: #8d8a82;
  stroke-width: 1.6;
  stroke-linejoin: round;
}
.world-editor__star:hover svg {
  stroke: var(--gold-light);
}
.world-editor__star.is-on svg {
  fill: var(--gold-main);
  stroke: var(--gold-main);
}
.world-editor__star:focus-visible {
  outline: 2px solid var(--gold-light);
}
.world-editor__more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  width: 100%;
  margin: 10px 0 4px;
}
.world-editor__more:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__more:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__more:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__more:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__empty {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
  padding: 18px 6px;
  text-align: left;
}
.world-editor__dock {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
}
.world-editor__picked {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.world-editor__picked--none {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.world-editor__picked-name {
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__picked-meta {
  font-size: 12px;
  color: #8d8a82;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__go {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
  padding: 11px 18px;
  font-size: 15px;
}
.world-editor__go:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__go:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__go:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__go:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__go:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.world-editor__list {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-right: 4px;
  padding-bottom: 12px;
}
.world-editor__list::-webkit-scrollbar {
  width: 6px;
}
.world-editor__list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.world-editor__row {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
}
.world-editor__row-body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.world-editor__row-name {
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__row-meta {
  font-size: 12px;
  color: #8d8a82;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.world-editor__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
}
.world-editor__btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.world-editor__btn:active:not(:disabled) {
  transform: translateY(1px);
}
.world-editor__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.world-editor__btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__btn--accent {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.world-editor__btn--accent:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.world-editor__btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.world-editor__btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.world-editor__btn--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.world-editor__btn--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}
.world-editor__tools {
  flex: none;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.world-editor__tool {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  text-align: left;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  cursor: pointer;
  transition: border-color 0.12s ease, background-color 0.12s ease;
}
.world-editor__tool:hover {
  border-color: var(--gold-dark);
  background: rgba(255, 255, 255, 0.07);
}
.world-editor__tool:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.world-editor__tool-title {
  font-size: 14px;
  font-weight: 600;
}
.world-editor__tool-text {
  font-size: 12.5px;
  line-height: 1.4;
  color: #8d8a82;
}
@media (max-width: 900px) {
  .world-editor {
    width: calc(100vw - 32px);
    min-width: 0;
  }
  .world-editor__split {
    grid-template-columns: 1fr;
  }
  .world-editor__tree {
    border-right: 0;
    padding-right: 0;
    max-height: 36vh;
  }
  .world-editor__grid {
    grid-template-columns: 1fr;
  }
  .world-editor__tools {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/features/worldEditor/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AANA;ED8BE,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECxKA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAcF;ADME;EAAI,sBAAA;ACHN;ADgJE;EC7KF;ID6K4C,eAAA;EC5I1C;AACF;AApBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,sBAAA;AAsBJ;AAnBE;ED+BA,kDA3BW;EA4BX,gBAAA;EACA,eChCqB;EDiCrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ECMH,SAAA;AA0BJ;AAvBE;EDyCA,eAAA;EACA,gBAAA;EACA,cAlDO;ECSL,eAAA;AA2BJ;AAxBE;EDiDA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;ACnDF;ADmBE;EAAyB,qCAAA;EAAuC,8BAAA;ACflE;ADgBE;EAA0B,0BAAA;ACb5B;ADcE;EAAa,YAAA;EAAc,mBAAA;ACV7B;ADWE;EAAkB,oCAAA;EAAsC,mBAAA;ACP1D;AD+BE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC1BhF;AA7DE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,kDAAA;AA+DJ;AA5DE;ED0IA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;AC3EF;AD6EE;EAAU,cAnLL;ACyGP;AD2EE;EAAkB,oCAAA;EAAsC,oBAAA;ACvE1D;AA/EI;ED0JF,wBAAA;EACA,qCAAA;ACxEF;AAhFE;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AAkFJ;AA/EE;EDQA,eAAA;EACA,gBAAA;EACA,cAlDO;EC0CL,sBAAA;EACA,eAAA;EACA,+CAAA;AAmFJ;AAhFE;EACE,kBAAA;EACA,UAAA;AAkFJ;AAhFI;ED+DF,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECrEI,mBAAA;AA0FN;ADnBE;EAAU,aAAA;EAAe,8BAAA;ACuB3B;ADtBE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC6B1G;AAlGI;EACE,aAAA;EACA,QAAA;AAoGN;AAlGM;EAAQ,mBAAA;AAqGd;AAjGE;EDHA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAyBA,cArGO;EAsGP,uBAAA;EACA,yBAAA;EAMA,iBAAA;EACA,eAAA;EC1CE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;AAqHJ;AD9GE;EAAyB,qCAAA;EAAuC,8BAAA;ACkHlE;ADjHE;EAA0B,0BAAA;ACoH5B;ADnHE;EAAa,YAAA;EAAc,mBAAA;ACuH7B;ADtHE;EAAkB,oCAAA;EAAsC,mBAAA;AC0H1D;ADlGE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACuGhF;AArIE;EACE,UAAA;EACA,aAAA;EACA,gDAAA;EACA,QAAA;AAuIJ;AApIE;EDrBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;EATA,cArGO;EAsGP,uBAAA;EACA,yBAAA;ECjBE,gBAAA;EACA,iBAAA;AAwJJ;ADjKE;EAAyB,qCAAA;EAAuC,8BAAA;ACqKlE;ADpKE;EAA0B,0BAAA;ACuK5B;ADtKE;EAAa,YAAA;EAAc,mBAAA;AC0K7B;ADzKE;EAAkB,oCAAA;EAAsC,mBAAA;AC6K1D;ADrJE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;AC0JhF;AA1KI;EACE,cD5FC;EC6FD,qCDjGO;ECkGP,8BAAA;AA4KN;AAvKE;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,2CAAA;EACA,SAAA;AAyKJ;AAtKE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,iDAAA;AAwKJ;AArKE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAuKJ;AApKE;EDoBA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECpBE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAwKJ;ADvJE;EAAuB,UAAA;AC0JzB;ADzJE;EAA6B,oCAAA;EAAsC,kBAAA;AC6JrE;AA5KE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,yDDpIQ;ECqIR,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDhJK;ECiJL,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,yDAAA;AA8KJ;AA5KI;EAAU,cDzJP;ECyJyB,qCAAA;AAgLhC;AA/KI;EAAkB,oCAAA;EAAsC,oBAAA;AAmL5D;AAjLI;EAAQ,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;AAsLlD;AArLI;EAAQ,kBAAA;EAAoB,gBAAA;EAAkB,iBAAA;EAAmB,cD3J5D;ACsVT;AAzLI;EACE,cDhKC;ECiKD,qCDrKO;ECsKP,mCAAA;AA2LN;AAvLE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAyLJ;AAtLE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAwLJ;AAtLI;ED3HF,eAAA;EACA,gBAAA;EACA,cAzDO;ECkLwB,eAAA;AA4LjC;AA1LI;EDjEF,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC2DI,gBAAA;EACA,eAAA;AAoMN;AD9PE;EAAU,aAAA;EAAe,8BAAA;ACkQ3B;ADjQE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACwQ1G;AA3ME;ED1IA,eAAA;EACA,gBAAA;EACA,cAlDO;EC4LL,SAAA;AA+MJ;AA5ME;EACE,UAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AA8MJ;AA3ME;EACE,gBAAA;EACA,cD5MG;EC6MH,gBAAA;EACA,uBAAA;EACA,mBAAA;AA6MJ;AA1ME;EACE,UAAA;EACA,cDlNK;AC8ZT;AAzME;EDrKA,eAAA;EACA,gBAAA;EACA,cAlDO;ECuNL,SAAA;EACA,mBAAA;EACA,eAAA;AA6MJ;AA1ME;ED9EA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC8EE,OAAA;EACA,aAAA;EACA,kBAAA;AA8MJ;AD5RE;EAAuB,UAAA;AC+RzB;AD9RE;EAA6B,oCAAA;EAAsC,kBAAA;ACkSrE;AAlNE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,gDAAA;EACA,QAAA;AAoNJ;AAjNE;EDjNA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC2OL,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gEAAA;AAqNJ;AAnNI;EAAU,8BAAA;EAAgC,qCAAA;AAuN9C;AAtNI;EAAkB,oCAAA;EAAsC,mBAAA;AA0N5D;AAxNI;EACE,8BAAA;EACA,qCAAA;AA0NN;AAtNE;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kDDhQS;ECiQT,eAAA;EACA,wBAAA;EACA,+BD9QQ;EC+QR,2CAAA;EACA,kBDxQK;ACgeT;AArNE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAuNJ;AApNE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;AAsNJ;AAnNE;EACE,eAAA;EACA,cDlSK;ECmSL,gBAAA;EACA,uBAAA;EACA,mBAAA;AAqNJ;AAlNE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;EACA,kBDhTK;ECiTL,eAAA;AAoNJ;AAlNI;EAAM,UAAA;EAAY,eDtTb;ECsTkC,iBAAA;EAAmB,sBAAA;AAwN9D;AAvNI;EAAc,yBAAA;AA0NlB;AAzNI;EAAc,sBAAA;EAAwB,wBAAA;AA6N1C;AA5NI;EAAkB,oCAAA;AA+NtB;AA5NE;ED/PA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ECkPE,WAAA;EACA,kBAAA;AA6OJ;AD9dE;EAAyB,qCAAA;EAAuC,8BAAA;ACkelE;ADjeE;EAA0B,0BAAA;ACoe5B;ADneE;EAAa,YAAA;EAAc,mBAAA;ACue7B;ADteE;EAAkB,oCAAA;EAAsC,mBAAA;AC0e1D;AAzPE;EDlRA,eAAA;EACA,gBAAA;EACA,cAlDO;ECoUL,iBAAA;EACA,gBAAA;AA6PJ;AAzPE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBD9UK;ACykBT;AAxPE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA0PJ;AAxPI;ED3SF,eAAA;EACA,gBAAA;EACA,cAlDO;ACwlBT;AA1PE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA4PJ;AAzPE;EACE,eAAA;EACA,cDxWK;ECyWL,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2PJ;AAxPE;EDjTA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EASA,cAjFU;EAkFV,4BAAA;EACA,8BAAA;EC0RE,kBAAA;EACA,eAAA;AA2QJ;AD/iBE;EAAyB,qCAAA;EAAuC,8BAAA;ACmjBlE;ADljBE;EAA0B,0BAAA;ACqjB5B;ADpjBE;EAAa,YAAA;EAAc,mBAAA;ACwjB7B;ADvjBE;EAAkB,oCAAA;EAAsC,mBAAA;AC2jB1D;ADnjBE;EAAyB,6BAAA;EAA+B,+BAAA;ACujB1D;AA3RE;EDvOA,gBAAA;EACA,qBAAA;EACA,qDAAA;ECuOE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AA+RJ;AD1gBE;EAAuB,UAAA;AC6gBzB;AD5gBE;EAA6B,oCAAA;EAAsC,kBAAA;ACghBrE;AAnSE;EDrWA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC+XL,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAuSJ;AApSE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAsSJ;AAnSE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAqSJ;AAlSE;EACE,eAAA;EACA,cD1ZK;EC2ZL,gBAAA;EACA,uBAAA;EACA,mBAAA;AAoSJ;AAjSE;EDnWA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ACumBF;ADvoBE;EAAyB,qCAAA;EAAuC,8BAAA;AC2oBlE;AD1oBE;EAA0B,0BAAA;AC6oB5B;AD5oBE;EAAa,YAAA;EAAc,mBAAA;ACgpB7B;AD/oBE;EAAkB,oCAAA;EAAsC,mBAAA;ACmpB1D;AAhUI;ED/UF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;ACkpBF;ADhpBE;EAAyB,6BAAA;EAA+B,+BAAA;ACopB1D;AAxUI;EDxUF,cA5FO;EA6FP,uBAAA;EACA,uCAAA;ACmpBF;ADjpBE;EAAyB,qCAAA;EAAuC,qBAhGzD;ACqvBT;AAhVI;EDjUF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACopBF;ADlpBE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACupBhF;AAvVE;EACE,UAAA;EACA,aAAA;EACA,gDAAA;EACA,QAAA;AAyVJ;AAtVE;EDrZA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;EC+aL,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,yDDhbQ;ECibR,cD1bG;EC2bH,eAAA;EACA,gEAAA;AA0VJ;AAxVI;EAAU,8BAAA;EAAgC,qCAAA;AA4V9C;AA3VI;EAAkB,oCAAA;EAAsC,mBAAA;AA+V5D;AA5VE;EACE,eAAA;EACA,gBAAA;AA8VJ;AA3VE;EACE,iBAAA;EACA,gBAAA;EACA,cDxcK;ACqyBT;AA1VE;EA/dF;IAgeI,yBAAA;IACA,YAAA;EA6VF;EA3VE;IAAW,0BAAA;EA8Vb;EA7VE;IAAU,eAAA;IAAiB,gBAAA;IAAkB,gBAAA;EAkW/C;EAjWE;IAAU,0BAAA;EAoWZ;EAnWE;IAAW,0BAAA;EAsWb;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// World editor of the staff: a build-mode panel docked on the left, the world stays visible on the right.\n.world-editor {\n  @include ink.panel;\n  @include ink.enter;\n  position: fixed;\n  top: 16px;\n  left: 16px;\n  bottom: 16px;\n  width: min(800px, 66vw);\n  min-width: 560px;\n  display: flex;\n  flex-direction: column;\n  z-index: 45;\n  overflow: hidden;\n\n  &__head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 16px 18px 6px;\n  }\n\n  &__title {\n    @include ink.title(22px);\n    margin: 0;\n  }\n\n  &__sub-title {\n    @include ink.hint;\n    margin: 4px 0 0;\n  }\n\n  &__close {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n  }\n\n  &__modes {\n    display: flex;\n    gap: 2px;\n    padding: 0 12px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__mode {\n    @include ink.tab;\n\n    &.is-active { @include ink.tab-active; }\n  }\n\n  &__body {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    padding: 12px 14px 0;\n    gap: 10px;\n  }\n\n  &__foot {\n    @include ink.hint;\n    padding: 8px 18px 12px;\n    font-size: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__search {\n    position: relative;\n    flex: none;\n\n    input {\n      @include ink.field;\n      padding-right: 74px;\n    }\n\n    &--inline {\n      display: flex;\n      gap: 8px;\n\n      input { padding-right: 11px; }\n    }\n  }\n\n  &__clear {\n    @include ink.button;\n    @include ink.button-quiet;\n    @include ink.button-sm;\n    position: absolute;\n    top: 50%;\n    right: 4px;\n    transform: translateY(-50%);\n  }\n\n  // Where to look: the catalog, the favourites, the recents\n  &__shelves {\n    flex: none;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 4px;\n  }\n\n  &__shelf {\n    @include ink.button;\n    @include ink.button-sm;\n    @include ink.button-quiet;\n    padding: 5px 4px;\n    font-size: 12.5px;\n\n    &.is-active {\n      color: ink.$text;\n      background: ink.$ink-raised;\n      border-color: var(--gold-dark);\n    }\n  }\n\n  // Tree on the left, objects on the right\n  &__split {\n    flex: 1;\n    min-height: 0;\n    display: grid;\n    grid-template-columns: 236px minmax(0, 1fr);\n    gap: 14px;\n  }\n\n  &__tree {\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-right: 12px;\n    border-right: 1px solid ink.$line;\n  }\n\n  &__content {\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  &__nodes {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding-right: 4px;\n  }\n\n  &__node {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    width: 100%;\n    padding: 6px 8px;\n    font-family: ink.$font-text;\n    font-size: 13.5px;\n    font-weight: 600;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-left: 2px solid transparent;\n    border-radius: 0 ink.$radius ink.$radius 0;\n    cursor: pointer;\n    transition: background-color 0.12s ease, color 0.12s ease;\n\n    &:hover { color: ink.$text; background: rgba(255, 255, 255, 0.06); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--d1 { padding-left: 20px; font-weight: 500; font-size: 13px; }\n    &--d2 { padding-left: 34px; font-weight: 400; font-size: 12.5px; color: ink.$text-3; }\n\n    &.is-active {\n      color: ink.$text;\n      background: ink.$ink-raised;\n      border-left-color: var(--gold-main);\n    }\n  }\n\n  &__node-label {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__source {\n    flex: none;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    > span { @include ink.label; font-size: 12px; }\n\n    select {\n      @include ink.field;\n      padding: 7px 9px;\n      font-size: 13px;\n    }\n  }\n\n  &__hint {\n    @include ink.hint;\n    margin: 0;\n  }\n\n  &__trail {\n    flex: none;\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 10px;\n    font-size: 13px;\n  }\n\n  &__trail-path {\n    font-weight: 600;\n    color: ink.$text;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__trail-count {\n    flex: none;\n    color: ink.$text-3;\n  }\n\n  &__sizehint {\n    @include ink.hint;\n    margin: 0;\n    padding-bottom: 8px;\n    font-size: 12px;\n  }\n\n  &__grid-wrap {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    padding-right: 4px;\n  }\n\n  &__grid {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  &__card {\n    @include ink.block;\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 34px 8px 8px;\n    min-width: 0;\n    cursor: pointer;\n    transition: border-color 0.12s ease, background-color 0.12s ease;\n\n    &:hover { border-color: var(--gold-dark); background: rgba(255, 255, 255, 0.07); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n\n    &.is-selected {\n      border-color: var(--gold-main);\n      background: rgba(255, 255, 255, 0.09);\n    }\n  }\n\n  &__tile {\n    flex: none;\n    width: 44px;\n    height: 44px;\n    display: grid;\n    place-items: center;\n    font-family: ink.$font-title;\n    font-size: 17px;\n    color: var(--gold-light);\n    background: ink.$ink-field;\n    border: 1px solid ink.$line;\n    border-radius: ink.$radius;\n  }\n\n  &__card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__card-name {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.25;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    word-break: break-word;\n  }\n\n  &__card-meta {\n    font-size: 12px;\n    color: ink.$text-3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__star {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    display: grid;\n    place-items: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    background: transparent;\n    border: 0;\n    border-radius: ink.$radius;\n    cursor: pointer;\n\n    svg { fill: none; stroke: ink.$text-3; stroke-width: 1.6; stroke-linejoin: round; }\n    &:hover svg { stroke: var(--gold-light); }\n    &.is-on svg { fill: var(--gold-main); stroke: var(--gold-main); }\n    &:focus-visible { outline: 2px solid var(--gold-light); }\n  }\n\n  &__more {\n    @include ink.button;\n    width: 100%;\n    margin: 10px 0 4px;\n  }\n\n  &__empty {\n    @include ink.hint;\n    padding: 18px 6px;\n    text-align: left;\n  }\n\n  // The picked object and the one big action, always in reach\n  &__dock {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 12px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid ink.$line-strong;\n    border-radius: ink.$radius;\n  }\n\n  &__picked {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    &--none { @include ink.hint; }\n  }\n\n  &__picked-name {\n    font-size: 15px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__picked-meta {\n    font-size: 12px;\n    color: ink.$text-3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__go {\n    @include ink.button;\n    @include ink.button-primary;\n    padding: 11px 18px;\n    font-size: 15px;\n  }\n\n  &__list {\n    @include ink.scroll;\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding-right: 4px;\n    padding-bottom: 12px;\n  }\n\n  &__row {\n    @include ink.block;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 10px;\n  }\n\n  &__row-body {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__row-name {\n    font-size: 14px;\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__row-meta {\n    font-size: 12px;\n    color: ink.$text-3;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__btn {\n    @include ink.button;\n    @include ink.button-sm;\n\n    &--accent { @include ink.button-primary; }\n    &--danger { @include ink.button-danger; }\n    &--quiet { @include ink.button-quiet; }\n  }\n\n  &__tools {\n    flex: none;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n  }\n\n  &__tool {\n    @include ink.block;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 12px;\n    text-align: left;\n    font-family: ink.$font-text;\n    color: ink.$text;\n    cursor: pointer;\n    transition: border-color 0.12s ease, background-color 0.12s ease;\n\n    &:hover { border-color: var(--gold-dark); background: rgba(255, 255, 255, 0.07); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n  }\n\n  &__tool-title {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  &__tool-text {\n    font-size: 12.5px;\n    line-height: 1.4;\n    color: ink.$text-3;\n  }\n\n  @media (max-width: 900px) {\n    width: calc(100vw - 32px);\n    min-width: 0;\n\n    &__split { grid-template-columns: 1fr; }\n    &__tree { border-right: 0; padding-right: 0; max-height: 36vh; }\n    &__grid { grid-template-columns: 1fr; }\n    &__tools { grid-template-columns: 1fr; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
